<div class="modal-dialog-wrapper">
  <div class="title-wrapper">
    <div class="title">Upload Image</div>
    <button (click)="close()">
      <mat-icon class="close-icon"> close </mat-icon>
    </button>
  </div>
  @if (isStartedUpload) {
    <div class="uploading-image-loader">
      <div class="loader-wrapper">
        @if (isImageUploading) {
          <mat-spinner [diameter]="24"></mat-spinner>
          <span>Background Image Loading</span>
        } @else if (isImageDone) {
          <mat-icon>check_circle</mat-icon>
          <span>Image Uploaded</span>
        }
      </div>
      <span class="loader-text">
        {{
          isImageUploading
            ? 'This may take some time depending on the size of the image.'
            : 'Your background image is ready to go.'
        }}
      </span>
    </div>
  } @else {
    <div class="modal-image-upload">
      <input hidden type="file" #uploader (change)="uploadFile($event)" accept="image/png, image/gif, image/jpeg" />
      @if (!imageSelected && !isImageToSmall && !imageToCropFile) {
        <button data-testid="uploadBtn" class="upload-button" (click)="uploader.click()">
          <div class="upload-image">
            <img src="/assets/images/upload_image.svg" alt="Upload image" />
          </div>
          <div class="upload-text">Select a file to upload</div>
        </button>
      } @else if (isImageToSmall) {
        <div class="small-wrapper">
          <div class="title-wrapper">
            <mat-icon>cancel</mat-icon>
            <span>Image Too Small</span>
          </div>
          <span class="info-text">
            Image Resolution Too Small for the room size. <br />
            Please select an image of {{ data.roomSize }}x{{ data.roomSize }}
            or larger to fit this room
          </span>
          <app-home-button class="w-fit" color="white" (click)="selectNewImage()"> Select New Image </app-home-button>
        </div>
      } @else if (imageToCropFile) {
        <div class="image-cropper-wrapper">
          <span class="cropper-title"> Crop Your Background to Fit The Room </span>
          <span class="cropper-subtitle"> Crop image to fit room size </span>
          <image-cropper
            #imageCropper
            style="max-height: 300px"
            [imageBase64]="imageToCropURI"
            [autoCrop]="false"
            output="base64"
            [maintainAspectRatio]="true"
            [aspectRatio]="100 / 100"
            [resizeToWidth]="data.roomSize"
            format="png"
            [(transform)]="transform"
            [allowMoveImage]="true"
          >
          </image-cropper>
          <div class="image-zoom-input">
            <mat-icon>image</mat-icon>
            <mat-slider class="w-full" min="1" max="500" step="1">
              <input matSliderThumb type="range" value="1" (change)="changeZoom($any($event.target).value)" />
            </mat-slider>
            <mat-icon class="icon-big">image</mat-icon>
          </div>
        </div>
      } @else {
        <div (click)="uploader.click()">
          <img src="{{ selectedImage }}" title="Preview Image Upload" alt="Preview Image Upload" class="image-upload" />
        </div>
      }
    </div>
  }
  <div class="footer-wrapper">
    <button data-testid="dialogSecondaryButton" class="secondary-button" mat-dialog-close (click)="close()">
      Cancel
    </button>
    <button
      data-testid="dialogPrimaryButton"
      class="primary-button"
      [disabled]="isImageToSmall || isImageUploading || (!imageSelected && !imageToCropFile)"
      (click)="confirm()"
    >
      {{ imageToCropFile ? 'Crop Image' : 'Confirm' }}
    </button>
  </div>
</div>
